export default __webpack_public_path__ + "static/media/GeneralSensor.75b12839.png";